module.exports = __webpack_public_path__ + "static/laptop_-73c697a8c226be9e7aa701fbc9847ec1.webp";